'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const hasVideo = css``;

export const isLandscape = css``;

export const sharpBorder = css`
  && {
    border-radius: 0;
    @media screen and (width > ${theme.sizes.screens.md}) {
      border-radius: 0.5rem;
    }
  }
`;

export const video = css`
  display: flex;
  justify-content: center;
  align-items: stretch;
  position: absolute;
  width: 100%;
  bottom: 0;
  top: calc(var(--layout-navbar) + var(--offset-top, calc(var(--layout-navbar) * -1)));
  z-index: 30;
  video {
    max-height: 100%;
    max-width: 100%;
  }
`;

export const feed = css`
  position: sticky;
  top: calc(var(--layout-navbar) + 80px);
  display: none;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: flex;
    justify-content: stretch;
    & > * {
      width: 100%;
    }
  }
`;

export const isLandscapeImage = css``;

export const imageBackground = css`
  &.${isLandscapeImage} {
    display: none;
  }
  position: absolute;
  inset: -2px;
  background-size: cover;
  background-position: center;
  background-origin: content-box;
  background-image: var(--image, '/logo-square.png');
  display: flex;
  align-items: center;
  justify-content: center;
  filter: blur(4px);
  transform: scale(1.1);
  transform-origin: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: none;
  }
`;

export const image = css`
  max-width: 40%;
  margin: 3rem auto;
  border-radius: 0.25rem;
  position: relative;
  z-index: 10;
  &.${isLandscapeImage} {
    max-width: 100%;
    width: 100%;
    margin: 0;
    border-radius: 0;
    @media screen and (width > ${theme.sizes.screens.md}) {
      aspect-ratio: unset;
    }
  }
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: none;
  }
`;

export const side = css`
  grid-area: side;
  position: relative;
  margin: 0 -0.75rem;
  overflow: hidden;
  aspect-ratio: 4/3;
  display: flex;
  align-items: center;
  &.${hasVideo} {
    aspect-ratio: unset;
    height: 60dvh;
    top: -25dvh;
    position: sticky;
    z-index: 30;
    @media screen and (width > ${theme.sizes.screens.md}) {
      height: auto;
      position: relative;
      top: auto;
    }
    &.${isLandscape} {
      height: 25dvh;
      top: var(--layout-navbar);
      video {
        object-fit: cover;
        width: 100%;
      }
      @media screen and (width > ${theme.sizes.screens.md}) {
        height: auto;
        position: relative;
        top: auto;
      }
    }
  }
  @media screen and (width > ${theme.sizes.screens.md}) {
    position: relative;
    display: initial;
    overflow: unset;
    margin: 0;
    aspect-ratio: unset;
  }
`;

export const bookTableBtn = css`
  position: absolute;
  bottom: 1.5rem;
  z-index: 30;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  left: 1rem;
  bottom: 1rem;
  transform: initial;
  i {
    color: ${theme.colors.primary[1]};
  }
`;
